window.loadPaint = setInterval(function() {
  let outs = document.querySelectorAll('.painting.out');
  if (outs.length < 1) {
    clearInterval(window.loadPaint);
    return false;
  }
  // With reduced motion the paintings are simply there, not swooped in one by one.
  if (document.documentElement.dataset.motion === 'reduce') {
    outs.forEach(el => el.classList.remove('out'));
    return false;
  }
  let j = 0;
  let top = window.scrollY;
  let bottom = top + window.innerHeight - 50;
  for (let i =0; i <outs.length; i++) {
    let el = outs[i];
    let elTop = el.parentNode.getBoundingClientRect().top;

    if (elTop < bottom) {
      setTimeout(function() {
        el.classList.remove('out');
      }, 1000 * j);
      j++;
    }
  }
}, 200);